module.exports = __webpack_public_path__ + "img/tmc-img.9b90a1c.png";